<template>
  <AppForm
    ref="form"
    :rules="rules"
    :values="formData"
    v-slot:default="{ formErrors }"
  >
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12">
        <AppFormItem label="Nome" :error="formErrors.name">
          <InputText v-model="formData.name" />
        </AppFormItem>
      </div>
      <div class="p-field p-col-12">
        <AppFormItem label="Descrição">
          <Textarea v-model="formData.description" rows="3" />
        </AppFormItem>
      </div>
    </div>
  </AppForm>
</template>

<script>
import { CashFlowCategoryApi } from '../../../services/api';

export default {
  name: 'CashFlowCategoryForm',
  data() {
    return {
      rules: {
        name: [{ required: true, message: 'Informe o nome.' }],
      },
      formData: {
        name: '',
        description: null,
      },
    };
  },
  methods: {
    reset() {
      this.formData = {
        name: '',
        description: null,
      };
    },
    async save() {
      try {
        if (!(await this.$refs.form.validate())) {
          return;
        }
        this.$emit('save-start');
        const body = { ...this.formData };
        await CashFlowCategoryApi.create(body);
        this.$emit('save-success');
      } catch (error) {
        this.handleError(error);
      } finally {
        this.$emit('save-end');
      }
    },
    handleError(error) {
      console.log(error);
      let detail = 'Não foi possível salvar a categoria.';
      this.$toast.add({
        severity: 'error',
        summary: 'Desculpe!',
        detail,
        life: 3000,
      });
    },
  },
};
</script>

<style>
</style>
